import {
  getBlogArticle,
  getBlogArticlePreview,
  getBlogArticles,
  getAllArticles
} from "../../lib/blog-articles";
import { getSEOPageProps } from "../../lib/seo";
import { ISR_TTL } from "../../config";

import Article from "../../components/article";
import NextStory from "../../components/next-story";
import SeoMeta from "../../components/seo-meta";

export default function NewsStoriesPage({ article, otherArticles, seo }) {
  return (
    <>
      <SeoMeta {...seo} />

      <Article article={article} />

      <div className="container">
        <div className="my-40">
          <NextStory articles={otherArticles.items} />
        </div>
      </div>
    </>
  );
}


export async function getStaticProps({ params, preview = false, previewData }) {
  try {
    let article, otherArticles, seo;

    // Handle preview mode using Next.js preview API
    if (preview && previewData?.preview) {
      try {
        const previewArticle = await getBlogArticlePreview(previewData.preview);
        return {
          props: {
            article: previewArticle,
            otherArticles: { items: previewArticle.nextStory ? [previewArticle.nextStory] : [] },
            seo: {}
          }
        };
      } catch (e) {
        return {
          notFound: true
        };
      }
    }

    // Normal ISR flow
    [article, otherArticles, seo] = await Promise.all([
      getBlogArticle(params.slug),
      getBlogArticles({ limit: 3, skip: 0 }), // take the latest 3 articles
      getSEOPageProps({ resolvedUrl: `/news/${params.slug}` })
    ]);

    if (!article) {
      return {
        notFound: true
      };
    }

    // filter out the current article, if it exists
    otherArticles.items = otherArticles.items.filter(
      (item) => item.slug !== params.slug
    );

    // slice two more articles
    otherArticles.items = otherArticles.items.slice(0, 2);

    // Push the related next story into the other article's list.
    if (article.nextStory) {
      otherArticles.items.push(article.nextStory);
    }

    return {
      props: {
        article,
        otherArticles,
        seo
      },
      revalidate: ISR_TTL.HIGH_FREQUENCY // 5 minutes - blog posts have dynamic content
    };
  } catch (e) {
    console.log(e.message);
    return {
      notFound: true
    };
  }
}

export async function getStaticPaths() {
  try {
    const articles = await getAllArticles();
    
    const paths = articles.map((article) => ({
      params: { slug: article.slug }
    }));

    return {
      paths,
      fallback: "blocking" // Enable ISR for new blog posts
    };
  } catch (e) {
    console.log(e.message);
    return {
      paths: [],
      fallback: "blocking"
    };
  }
}
